const BaseComponent = require('base/base-component');

class articleBlock extends BaseComponent {
  constructor(){
    super()
  }
  init () {
    this.$listContainer = this.$el.find('.list-content');
    if (this.$listContainer.find('>li').length === 0) {
      this.$listContainer.append('<p class="noData">暂无数据</p>');
    }
  }
}
module.exports = articleBlock;
